import { tablesDB, DATABASE_ID, PRODUCTS_TABLE_ID, ORDERS_TABLE_ID, Query } from '../lib/appwrite';

export async function listProducts(queries = []) {
  const res = await tablesDB.listRows(DATABASE_ID, PRODUCTS_TABLE_ID, queries);
  return res.rows || [];
}

export async function getProduct(productId) {
  const res = await tablesDB.listRows(DATABASE_ID, PRODUCTS_TABLE_ID, [
    Query.equal('productId', productId),
  ]);
  const rows = res.rows || [];
  return rows[0] || null;
}

export async function getProductByRowId(rowId) {
  return tablesDB.getRow(DATABASE_ID, PRODUCTS_TABLE_ID, rowId);
}

export async function getProductOrders(productId, productName) {
  const res = await tablesDB.listRows(DATABASE_ID, ORDERS_TABLE_ID, [
    Query.orderDesc('orderDate'),
    Query.limit(500),
  ]);
  const all = res.rows || [];
  return all.filter(
    (o) =>
      o.productId === productId ||
      (o.productName || '').toLowerCase() === (productName || '').toLowerCase()
  );
}

export async function updateProduct(rowId, data) {
  return tablesDB.updateRow(DATABASE_ID, PRODUCTS_TABLE_ID, rowId, data);
}

export async function deleteProduct(rowId) {
  return tablesDB.deleteRow(DATABASE_ID, PRODUCTS_TABLE_ID, rowId);
}
